module.exports = __webpack_public_path__ + "img/new_index_cases14.fbbfbd27.png";